(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["p1s-common-react"] = factory(require("react"));
	else
		root["p1s-common-react"] = factory(root["React"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__442__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 442:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__442__;

/***/ }),

/***/ 368:
/***/ ((module, exports) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
  'use strict';

  var hasOwn = {}.hasOwnProperty;
  function classNames() {
    var classes = '';
    for (var i = 0; i < arguments.length; i++) {
      var arg = arguments[i];
      if (arg) {
        classes = appendClass(classes, parseValue(arg));
      }
    }
    return classes;
  }
  function parseValue(arg) {
    if (typeof arg === 'string' || typeof arg === 'number') {
      return arg;
    }
    if (typeof arg !== 'object') {
      return '';
    }
    if (Array.isArray(arg)) {
      return classNames.apply(null, arg);
    }
    if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
      return arg.toString();
    }
    var classes = '';
    for (var key in arg) {
      if (hasOwn.call(arg, key) && arg[key]) {
        classes = appendClass(classes, key);
      }
    }
    return classes;
  }
  function appendClass(value, newClass) {
    if (!newClass) {
      return value;
    }
    if (value) {
      return value + ' ' + newClass;
    }
    return value + newClass;
  }
  if ( true && module.exports) {
    classNames.default = classNames;
    module.exports = classNames;
  } else if (true) {
    // register as 'classnames', consistent with npm package name
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return classNames;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
})();

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  AuthenticationTypeEnum: () => (/* reexport */ constants_AuthenticationTypeEnum),
  BannerType: () => (/* reexport */ constants_BannerType),
  NotificationsPopupPosition: () => (/* reexport */ constants_NotificationsPopupPosition),
  OrganizationStatusEnum: () => (/* reexport */ constants_OrganizationStatusEnum),
  OrganizationTypeEnum: () => (/* reexport */ constants_OrganizationTypeEnum),
  ProductEnum: () => (/* reexport */ constants_ProductEnum),
  ProductType: () => (/* reexport */ ProductTypeEnum),
  TicketType: () => (/* reexport */ constants_TicketType),
  UserRolesEnum: () => (/* reexport */ constants_UserRolesEnum)
});

;// CONCATENATED MODULE: ./src/constants/AuthenticationTypeEnum.js
var AuthenticationTypeEnum = {
  User: {
    value: "User",
    label: "Site/User/Password",
    text: "Site/User/Password",
    description: "Users log in with site number, user number, and password.",
    iconClass: "material-icons",
    materialIcon: "settings_input_component"
  },
  Sso: {
    value: "Sso",
    label: "Single Sign-On",
    text: "SSO",
    description: "Users log in using credentials managed by their organization.",
    iconClass: "material-icons",
    materialIcon: "vpn_key"
  },
  Password: {
    value: "Password",
    label: "Password",
    text: "Password",
    description: "Users log in using passwords they create and manage themselves.",
    iconClass: "material-icons",
    materialIcon: "lock"
  }
};
var getAuthenticationTypeByValue = function getAuthenticationTypeByValue(value) {
  var authenticationType = null;
  switch (value) {
    case AuthenticationTypeEnum.User.value:
      authenticationType = AuthenticationTypeEnum.User;
      break;
    case AuthenticationTypeEnum.Sso.value:
      authenticationType = AuthenticationTypeEnum.Sso;
      break;
    case AuthenticationTypeEnum.Password.value:
      authenticationType = AuthenticationTypeEnum.Password;
      break;
  }
  return authenticationType;
};
/* harmony default export */ const constants_AuthenticationTypeEnum = (AuthenticationTypeEnum);
;// CONCATENATED MODULE: ./src/constants/OrganizationStatusEnum.js
var OrganizationStatusEnum = {
  Active: {
    value: "Active",
    label: "Active"
  },
  Locked: {
    value: "Locked",
    label: "Locked"
  },
  SuperUsersOnly: {
    value: "SuperUsersOnly",
    label: "Superuser Only"
  }
};
/* harmony default export */ const constants_OrganizationStatusEnum = (OrganizationStatusEnum);
;// CONCATENATED MODULE: ./src/constants/OrganizationTypeEnum.js
var OrganizationTypeEnum = {
  Separate: "separate",
  Subordinate: "subordinate",
  Parent: "parent",
  P1S: "p1s"
};
/* harmony default export */ const constants_OrganizationTypeEnum = (OrganizationTypeEnum);
;// CONCATENATED MODULE: ./src/constants/UserRolesEnum.js
var UserRolesEnum = {
  StandardUserProfileId: 1,
  HealthSystemAdminProfileId: 3,
  UserManagerProfileId: 4,
  SafetyAdminProfileId: 5,
  SurveillanceAdminProfileId: 6
};
/* harmony default export */ const constants_UserRolesEnum = (UserRolesEnum);
;// CONCATENATED MODULE: ./src/constants/ProductTypeEnum.js
var ProductType = {
  surveillance: 0,
  safety: 1,
  tools: 2
};
/* harmony default export */ const ProductTypeEnum = (ProductType);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(368);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/entities/Icon.js
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var IconTypes = {
  "default": 0,
  material: 1,
  jumpstart: 2,
  svg: 3
};
var Icon = /*#__PURE__*/function () {
  function Icon(name) {
    var _this = this;
    var iconType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : IconTypes["default"];
    var extraClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    _classCallCheck(this, Icon);
    _defineProperty(this, "addClasses", function (extraClasses) {
      return _this.extraClass = classnames_default()(_this.extraClass, extraClasses);
    });
    this.name = name;
    this.iconType = iconType;
    this.extraClass = extraClass;
  }

  /**
   * @deprecated use IconView
   */
  return _createClass(Icon, [{
    key: "isMaterial",
    get: function get() {
      return this.iconType === IconTypes.material;
    }
  }]);
}();

// EXTERNAL MODULE: external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}
var external_root_React_commonjs2_react_commonjs_react_amd_react_ = __webpack_require__(442);
var external_root_React_commonjs2_react_commonjs_react_amd_react_default = /*#__PURE__*/__webpack_require__.n(external_root_React_commonjs2_react_commonjs_react_amd_react_);
;// CONCATENATED MODULE: ./src/constants/ProductEnum.js



var productIds = {
  pharmacyProductId: 1,
  quantifyProductId: 2,
  infectionPreventionProductId: 3,
  veriFormProductId: 4,
  ruleProductId: 5,
  analyticsProductId: 6,
  simplifiProductId: 7,
  pocAdvisorProductId: 8,
  medStorageProductId: 9,
  sepsisMonitorProductId: 10,
  medTraysProductId: 11,
  patientDecompensationId: 12,
  documentationProductId: 13,
  aurReportingProductId: 14,
  flowlyticsProductId: 15,
  ivWorkflowProductId: 16,
  userManagementProductId: 99,
  superUserProductId: 101
};

// structure of enum:
//         id -  product id in Identifi, should be the same in all applications
//         name -  name of product,
//         abbreviation -
//         type - type of product (for grouping),
//         icon - object of type Icon like new Icon("icon-pill"),
//         iconContainerClass - class of patent element,
//         label - visible product name in left menu (if there is no override in "leftMenuLabel") and in Product Selector in Identifi,
//         iconClass - string of icon class name in Identifi (Product Selector),
//         iconName - string of icon name in Identifi (Product Selector),
//         tileClassName - class name for tile in Identifi Product Selector,
//         leftMenuLabel - visible product name in left menu
//         ariaLabel - aria-label attribute
var ProductEnum = {
  Pharmacy: {
    id: productIds.pharmacyProductId,
    name: "Sentri7 Pharmacy",
    abbreviation: "s7",
    type: ProductTypeEnum.surveillance,
    icon: new Icon("icon-pill"),
    iconContainerClass: "icon-product",
    label: /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("span", null, "Pharmacy"),
    iconClass: "custom-icon icon-pill",
    tileClassName: "pharmacy"
  },
  Quantifi: {
    id: productIds.quantifyProductId,
    name: "Quantifi",
    abbreviation: "q",
    type: ProductTypeEnum.surveillance,
    icon: new Icon("ion-md-stats"),
    iconContainerClass: "icon-product",
    iconClass: "icon ion-stats-bars",
    tileClassName: "quantifi",
    label: /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("span", null, "Quantifi", /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("sup", null, "\xAE"))
  },
  InfectionPrevention: {
    id: productIds.infectionPreventionProductId,
    name: "Sentri7 Infection Prevention",
    abbreviation: "s7",
    type: ProductTypeEnum.surveillance,
    icon: new Icon("ion-md-bug"),
    iconContainerClass: "icon-product",
    iconClass: "icon bug_report",
    tileClassName: "ip",
    label: /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("span", null, "Infection Prevention")
  },
  Veriform: {
    id: productIds.veriFormProductId,
    name: "Veriform",
    abbreviation: "v",
    type: ProductTypeEnum.safety,
    icon: new Icon("ion-md-clipboard"),
    iconContainerClass: "icon-product",
    iconClass: "custom-icon list-alt--outline",
    tileClassName: "veriform",
    label: /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("span", null, "VeriForm", /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("sup", null, "\xAE"))
  },
  Simplifi: {
    id: productIds.simplifiProductId,
    name: "Simplifi 797",
    abbreviation: "s",
    type: ProductTypeEnum.safety,
    icon: new Icon("icon-syringe"),
    iconContainerClass: "icon-product",
    iconClass: "icon-syringe",
    tileClassName: "simplifi",
    label: /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("span", null, "Simplifi 797", /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("sup", null, "\xAE"))
  },
  Analytics: {
    id: productIds.analyticsProductId,
    name: "Analytics",
    abbreviation: "a",
    type: ProductTypeEnum.tools,
    icon: new Icon("ion-md-pulse"),
    iconContainerClass: "permission-analytics",
    iconClass: "icon ion-ios-pulse-strong",
    tileClassName: "analytics",
    label: /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("span", null, "Analytics")
  },
  UserManagement: {
    id: productIds.userManagementProductId,
    name: "Settings & User Management",
    abbreviation: "cm",
    type: ProductTypeEnum.tools,
    icon: new Icon("icon-cogs"),
    iconContainerClass: "permission-userManagement",
    iconClass: "icon settings",
    tileClassName: "admin",
    label: /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("span", null, "Settings & User Management")
  },
  RuleManagement: {
    id: productIds.ruleProductId,
    name: "Rules Management",
    abbreviation: "rm",
    type: ProductTypeEnum.tools,
    icon: new Icon("widgets"),
    iconContainerClass: "permission-ruleManagement",
    iconClass: "icon widgets",
    tileClassName: "rules",
    label: /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("span", null, "Rules Management")
  },
  PocAdvisor: {
    id: productIds.pocAdvisorProductId,
    name: "POC Advisor",
    abbreviation: "pa",
    type: ProductTypeEnum.surveillance,
    icon: new Icon("flag"),
    iconContainerClass: "icon-product",
    iconClass: "icon flag",
    tileClassName: "pocadvisor",
    label: /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("span", null, "POC Advisor", /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("sup", null, "\xAE"))
  },
  SuperUser: {
    id: productIds.superUserProductId,
    name: "Super User",
    abbreviation: "",
    type: ProductTypeEnum.tools,
    icon: new Icon("ion-ios-color-wand"),
    iconContainerClass: "icon-product",
    iconClass: "icon ion-ios-color-wand",
    tileClassName: "superuser",
    label: /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("span", null, "Super User")
  },
  MedStorage: {
    id: productIds.medStorageProductId,
    name: "Simplifi+ MedStorage",
    abbreviation: "m",
    type: ProductTypeEnum.safety,
    icon: new Icon("checklist"),
    iconContainerClass: "icon-product",
    iconClass: "checklist",
    tileClassName: "med-storage",
    label: /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("span", null, "Simplifi+", /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("sup", null, "\xAE"), " MedStorage"),
    leftMenuLabel: /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("span", null, "MedStorage"),
    ariaLabel: "Simplify Plus MedStorage"
  },
  MedTrays: {
    id: productIds.medTraysProductId,
    name: "Simplifi+ MedTrays",
    abbreviation: "mt",
    type: ProductTypeEnum.safety,
    icon: new Icon("view_quilt"),
    iconContainerClass: "icon-product med-trays",
    iconClass: "icon view_quilt",
    tileClassName: "med-trays",
    label: /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("span", null, "Simplifi+", /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("sup", null, "\xAE"), " MedTrays"),
    leftMenuLabel: /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("span", null, "MedTrays"),
    ariaLabel: "Simplify Plus MedTrays"
  },
  SepsisMonitor: {
    id: productIds.sepsisMonitorProductId,
    name: "Sepsis Monitor",
    abbreviation: "fl",
    type: ProductTypeEnum.surveillance,
    icon: new Icon("custom-icon icon-policy"),
    iconContainerClass: "icon-product",
    iconClass: "custom-icon icon-policy",
    tileClassName: "sepsis-monitor",
    label: /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("span", null, "Sepsis Monitor")
  },
  PatientDecompensation: {
    id: productIds.patientDecompensationId,
    name: "Pharmacy (New)",
    abbreviation: "pd",
    type: ProductTypeEnum.surveillance,
    // Icon name should be in pascal case for svg icons both here and in assets/svg as they will be converted to react components
    icon: new Icon("SvgPharmacyNew", IconTypes.svg, "pharmacy-new"),
    iconContainerClass: "icon-product",
    iconClass: "pharmacy-new",
    tileClassName: "pharmacy-new-tile",
    label: /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("span", null, "Pharmacy (New)"),
    ariaLabel: "Pharmacy New"
  },
  AurReporting: {
    id: productIds.aurReportingProductId,
    name: "AUR Reporting",
    abbreviation: "aur",
    type: ProductTypeEnum.surveillance,
    iconClass: "material-symbols-outlined",
    icon: new Icon("icon-data-exploration"),
    iconContainerClass: "icon-product",
    tileClassName: "S7AurOnly",
    label: /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("span", null, "AUR Reporting")
  },
  Flowlytics: {
    id: productIds.flowlyticsProductId,
    name: "Drug Diversion",
    abbreviation: "fl",
    type: ProductTypeEnum.surveillance,
    icon: new Icon("icon-alt-route"),
    iconContainerClass: "icon-product",
    label: /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("span", null, "Drug Diversion"),
    iconClass: "material-symbols-outlined",
    tileClassName: "flowlytics"
  },
  IVWorkflow: {
    id: productIds.ivWorkflowProductId,
    name: "Simplifi+ IV Workflow",
    abbreviation: "ivw",
    type: ProductTypeEnum.safety,
    icon: new Icon("iv-workflow"),
    iconContainerClass: "icon-product",
    label: /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("span", null, "Simplifi+", /*#__PURE__*/external_root_React_commonjs2_react_commonjs_react_amd_react_default().createElement("sup", null, "\xAE"), " IV Workflow"),
    iconClass: "iv-workflow",
    tileClassName: "ivWorkflow",
    ariaLabel: "Simplify Plus IV Workflow"
  }
};
/* harmony default export */ const constants_ProductEnum = (ProductEnum);
;// CONCATENATED MODULE: ./src/constants/TicketType.js
var TicketType = {
  virtualUser: {
    activateAccount: "ActivateAccount",
    setEmail: "SetEmail",
    resetPassword: "ResetPassword"
  },
  user: {
    resetPassword: "ResetPassword",
    upgradeToVirtualUser: "UpgradeToVirtualUser"
  }
};
/* harmony default export */ const constants_TicketType = (TicketType);
;// CONCATENATED MODULE: ./src/constants/NotificationsPopupPosition.js
var NotificationsPopupPosition = {
  topLeft: "toast-top-left",
  topRight: "toast-top-right",
  bottomLeft: "toast-bottom-left",
  bottomRight: "toast-bottom-right"
};
/* harmony default export */ const constants_NotificationsPopupPosition = (NotificationsPopupPosition);
;// CONCATENATED MODULE: ./src/constants/BannerType.js
var BannerType = {
  maintenance: "Maintenance",
  announcement: "Announcement"
};
/* harmony default export */ const constants_BannerType = (BannerType);
;// CONCATENATED MODULE: ./src/constants/index.js









})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});